import { formatSingaporeDate, formatSingaporeDateTime } from "../../../shared/timezone";

/**
 * Format a date value to "10 March 2026" style (no slashes, full month name).
 * Accepts Date objects, ISO strings, or timestamps.
 */
export function formatDate(value: Date | string | number | null | undefined): string {
  return formatSingaporeDate(value, { day: "numeric", month: "long", year: "numeric" }, "en-GB");
}

/**
 * Format a date+time value to "10 March 2026, 14:30" style.
 */
export function formatDateTime(value: Date | string | number | null | undefined): string {
  const dt = formatSingaporeDateTime(
    value,
    { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false },
    "en-GB"
  );
  return dt === "—" ? dt : dt.replace(",", "");
}
